import cn from 'classnames';
// Types
import { IconNames } from 'ui3/MillionsIcon/MillionsIcon';
// Ui3
import LinkButton from 'ui3/LinkButton/LinkButton';
import Text from 'ui3/Text/Text';
// Styles
import styles from './Section.module.scss';

type AllOrNone<T> = T | { [k in keyof T]?: never };

type LinkData = AllOrNone<{
  seeAllLink: string;
  seeAllLinkTitle: string;
}>;

type SectionProps = {
  title: string;
  backgroundTitle?: string;
  theme?: 'white' | 'black';
  className?: string;
  icon?: IconNames | 'none';
  subVariant?: 'text' | 'outlined' | 'none';
  headerPadding?: 'default' | 'none';
  headerRightContent?: React.ReactNode;
} & LinkData;

const Section: React.FC<SectionProps> = ({
  title,
  seeAllLink,
  seeAllLinkTitle,
  className,
  children,
  icon = 'chevronRight',
  subVariant = 'text',
  headerPadding = 'default',
  headerRightContent,
}) => {
  const isExternalLink = seeAllLink?.startsWith('http');

  return (
    <section className={cn(styles.root, className)}>
      {(title || seeAllLink || headerRightContent) && (
        <div
          className={cn(styles.header, {
            [styles.noHeaderPadding]: headerPadding === 'none',
          })}
        >
          {title && (
            <Text as="h2" variant="h5" color="lights-high">
              {title}
            </Text>
          )}

          {(headerRightContent || seeAllLink) && (
            <div className={styles.headerRight}>
              {headerRightContent}
              {seeAllLink && (
                <LinkButton
                  variant="secondary"
                  link={seeAllLink}
                  iconPosition="right"
                  iconSize={22}
                  className={subVariant !== 'none' ? styles.linkButton : ''}
                  target={isExternalLink ? '_blank' : undefined}
                  rel={isExternalLink ? 'noopener' : undefined}
                  {...(icon !== 'none' && { icon })}
                  {...(subVariant !== 'none'
                    ? { subVariant }
                    : { size: 'medium' })}
                >
                  {seeAllLinkTitle}
                </LinkButton>
              )}
            </div>
          )}
        </div>
      )}

      <div
        className={cn(styles.body, {
          [styles.noHeader]: !title,
        })}
      >
        {children}
      </div>
    </section>
  );
};

export default Section;
